import RoomType from '../roomType';
export default class Balcony extends RoomType {
    constructor() {
        super();
        this.id = 'Balcony';
        this.name = "Balkong";
        this.icon = "mdi-door";
        this.stateQuestions.questions = [
            {
                'id': 'doors',
                'title': 'Dører',
                'active': true,
                'value': -1
            },
            {
                'id': 'sluk',
                'title': 'Sluk',
                'active': true,
                'value': -1
            }
        ];
        this.cleanQuestions.questions = [
            {
                'id': 'door',
                'title': 'Dør',
                'active': true,
                'value': -1
            },
            {
                'id': 'floor',
                'title': 'Gulv',
                'active': true,
                'value': -1
            }
        ];

        this.contentTypes.options = [
            {
                'id': 'grill',
                'title': 'Grill',
                'active': false,
                'value': -1
            },
            {
                'id': 'seating',
                'title': 'Sittegruppe',
                'active': false,
                'value': -1
            },
        ];

        this.ceilingTypes = {
            'options': [
                {
                    'id': 'panel',
                    'title': 'Panel'
                },
                {
                    'id': 'plaster',
                    'title': 'Gips'
                },
                {
                    'id': 'painted',
                    'title': 'Malt himling'
                },
                {
                    'id': 'ace',
                    'title': 'Tak-ess'
                },
            ]
        };
        this.floorTypes = {
            'options': [
                {
                    'id': 'stone',
                    'title': 'Belegningsstein'
                },
                {
                    'id': 'asfalt',
                    'title': 'Asfalt'
                },
                {
                    'id': 'grass',
                    'title': 'Gress'
                },
                {
                    'id': 'wood',
                    'title': 'Terrassebord'
                },
                {
                    'id': 'composit',
                    'title': 'Komposittbord'
                },
            ]
        };
        this.wallTypes = {
            'options': [
                {
                    'id': 'cladding',
                    'title': 'Kledning'
                },
                {
                    'id': 'mur',
                    'title': 'Murvegg'
                },
                {
                    'id': 'composit',
                    'title': 'Komposittkledning'
                },
                {
                    'id': 'other',
                    'title': 'Annet'
                },
            ]
        };
        this.ceilingTypes = {
            'options': []
        };
        this.lightingTypes = {
            'options': [
                {
                    'id': 'outside',
                    'title': 'Utebelysning - frittstående'
                },
                {
                    'id': 'ouside_wall',
                    'title': 'Utebelysning - vegglampe'
                },
            ]
        };
        this.heatingTypes = {
            'options': [
                {
                    'id': 'gas',
                    'title': 'Gassvarmer'
                },
                {
                    'id': 'electric',
                    'title': 'Elektrisk varmer'
                },
            ]
        };
    }
}